"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkdownStreamingProvider = void 0;
exports.useMarkdownStreaming = useMarkdownStreaming;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MarkdownStreamingContext = /*#__PURE__*/(0, _react.createContext)(false);
var MarkdownStreamingProvider = exports.MarkdownStreamingProvider = function MarkdownStreamingProvider(_ref) {
  var isStreaming = _ref.isStreaming,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(MarkdownStreamingContext.Provider, {
    value: isStreaming,
    "data-sentry-element": "MarkdownStreamingContext.Provider",
    "data-sentry-component": "MarkdownStreamingProvider",
    "data-sentry-source-file": "MarkdownStreamingContext.tsx",
    children: children
  });
};
function useMarkdownStreaming() {
  return (0, _react.useContext)(MarkdownStreamingContext);
}